import { render, staticRenderFns } from "./qysList.vue?vue&type=template&id=64f72c52&scoped=true&"
import script from "./qysList.vue?vue&type=script&lang=js&"
export * from "./qysList.vue?vue&type=script&lang=js&"
import style0 from "./qysList.vue?vue&type=style&index=0&id=64f72c52&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f72c52",
  null
  
)

export default component.exports